import { Outlet } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { Pencil } from "lucide-react"
import { useReveniIntegrationQuery } from "modules/settings/hooks/reveni/useReveniIntegrationQuery"
import { useTranslation } from "react-i18next"
import { CheckReturn } from "./components/checkReturn"

export const ReveniConfiguration = () => {
  const { t } = useTranslation()
  const { data } = useReveniIntegrationQuery()
  const hasConfiguration = Boolean(data?.stores.length)
  const disabledReason = t("settings.integrations.disabledRequiresConfiguration")

  return (
    <>
      <div className="flex flex-col gap-8">
        <Card>
          <CardHeader className="flex flex-row gap-4 p-4">
            <div className="grow flex flex-col gap-1">
              <CardTitle>{t("settings.integrations.reveni.integrationCard.title")}</CardTitle>
              <CardDescription>
                {hasConfiguration
                  ? t("settings.integrations.reveni.integrationCard.descriptionDone")
                  : t("settings.integrations.reveni.integrationCard.descriptionPending")}
              </CardDescription>
            </div>
            <div className="flex items-center">
              {hasConfiguration ? (
                <div className="flex gap-2">
                  <BadgePingText
                    color={"success"}
                    text={t("settings.integrations.reveni.integrationCard.connected")}
                  />
                  <ButtonLink
                    variant={"ghost"}
                    size="icon"
                    to="/settings/integrations/reveni/connect"
                  >
                    <Pencil />
                  </ButtonLink>
                </div>
              ) : (
                <ButtonLink to={"/settings/integrations/reveni/connect"}>
                  {t("settings.integrations.reveni.integrationCard.configButton")}
                </ButtonLink>
              )}
            </div>
          </CardHeader>
        </Card>
        <Section title={t("settings.integrations.reveni.tools")}>
          <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
            <CheckReturn isDisabled={!hasConfiguration} disabledReason={disabledReason} />
          </div>
        </Section>
      </div>
      <Outlet />
    </>
  )
}
